var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"advertisement"},[_vm._m(0),_c('userRecords')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"advertisement-header"},[_c('div',{staticClass:"advertisement-header-text"},[_c('h3',[_vm._v("用户审核")])])])
}]

export { render, staticRenderFns }